'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fontWeights = exports.fontWeightPropTypes = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fontWeights = {
  fontWeightBold: function fontWeightBold(_ref) {
    var theme = _ref.theme;
    return '\n    font-weight: ' + theme.fontWeights.bold + ';\n  ';
  },

  fontWeightLight: function fontWeightLight(_ref2) {
    var theme = _ref2.theme;
    return '\n    font-weight: ' + theme.fontWeights.light + ';\n  ';
  },

  fontWeightMedium: function fontWeightMedium(_ref3) {
    var theme = _ref3.theme;
    return '\n    font-weight: ' + theme.fontWeights.medium + ';\n  ';
  },

  fontWeightRegular: function fontWeightRegular(_ref4) {
    var theme = _ref4.theme;
    return '\n    font-weight: ' + theme.fontWeights.normal + ';\n  ';
  }
};

var fontWeightPropTypes = {
  fontWeights: _propTypes2.default.shape({
    bold: _propTypes2.default.number.isRequired,
    light: _propTypes2.default.number.isRequired,
    medium: _propTypes2.default.number.isRequired,
    normal: _propTypes2.default.number.isRequired
  }).isRequired
};

exports.fontWeightPropTypes = fontWeightPropTypes;
exports.fontWeights = fontWeights;


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/modifiers/fontWeights.js
// module id = 1520
// module chunks = 2